import i18n from 'i18next';
import { groupBy, sortBy } from 'lodash';

import { type AtlasGqlCollaboratorsFragmentFragment, type AtlasGqlUser } from 'types/atlas-graphql';

const NO_ORG_NAME = 'No Organization';

export const groupCollaborators = (collaborators: AtlasGqlCollaboratorsFragmentFragment[]) => {
  const grouped = groupBy(collaborators, (c) => c.defaultOrganization?.name ?? NO_ORG_NAME);
  const orgNames = sortBy(Object.keys(grouped), [
    (orgName) => orgName === NO_ORG_NAME,
    (orgName) => orgName.toLowerCase(),
  ]);

  return orgNames.map((orgName) => ({
    orgName,
    collaborators: sortBy(grouped[orgName], [
      (c) => c.firstName?.toLowerCase(),
      (c) => c.lastName?.toLowerCase(),
    ]),
  }));
};

export const sortCollaborators = (
  collaborators: AtlasGqlUser[] | AtlasGqlCollaboratorsFragmentFragment[]
) =>
  sortBy(collaborators, [
    (c) => !c.defaultOrganization?.name,
    (c) => c.defaultOrganization?.name?.toLowerCase(),
    (c) => c.firstName?.toLowerCase(),
    (c) => c.lastName?.toLowerCase(),
  ]);

export const formatCollaborator = (
  collaborator: AtlasGqlUser | AtlasGqlCollaboratorsFragmentFragment
) => {
  const { firstName, lastName, email, defaultOrganization } = collaborator;
  // We at least need email or defaultOrganization to show a user
  if (!email && !defaultOrganization?.name) {
    return i18n.t('components.invalidUser', '(Invalid User)');
  }

  const userName = firstName && lastName ? `${firstName} ${lastName} (${email})` : `${email}`;
  const orgName = defaultOrganization?.name ? ` | ${defaultOrganization.name}` : '';

  return `${userName}${orgName}`;
};
